(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hdc-product-row"] && !Shopify.designMode) return;
  try {
    (function () {
    /* ── Utility functions ── */
    function formatPrice(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getActiveTier(bagCount, tiers) {
      var active = null;
      for (var i = 0; i < tiers.length; i++) {
        if (bagCount >= tiers[i].minBags) active = tiers[i];
        else break;
      }
      return active;
    }

    /* ── Parse discount tiers (shared JSON script tag) ── */
    function parseDiscountTiers() {
      var el = document.querySelector('[data-discount-tiers]');
      if (!el) return [];
      try {
        var tiers = JSON.parse(el.textContent || '[]');
        tiers.sort(function (a, b) {
          return a.minBags - b.minBags;
        });
        return tiers;
      } catch (e) {
        return [];
      }
    }

    /* ── Init a single product list instance ── */
    function initProductList(listEl) {
      var selections = {};
      var discountTiers = parseDiscountTiers();
      var currentStyle = listEl.dataset.hdcPlDefaultStyle || 'whole';
      var purchaseType = 'subscribe';
      var autoSelect = listEl.dataset.hdcPlAutoSelect !== 'false';
      var hoverTargetSelector = listEl.dataset.hdcPlHoverTarget || null;
      var lastActiveHandle = null;
      var hoverRevertTimer = null;

      /* ── Selection helpers ── */
      function getProductDataFromRow(row) {
        return {
          handle: row.dataset.productHandle || '',
          quantity: 1,
          variantWholeId: parseInt(row.dataset.variantWholeId || '0', 10),
          variantGroundId: parseInt(row.dataset.variantGroundId || '0', 10),
          variantWholePriceCents: parseInt(row.dataset.variantWholePrice || '0', 10),
          variantGroundPriceCents: parseInt(row.dataset.variantGroundPrice || '0', 10),
          title: row.dataset.productTitle || '',
          description: row.dataset.productDescription || '',
          imageUrl: row.dataset.productImage || '',
          weight: parseFloat(row.dataset.productWeight || '340'),
        };
      }

      function getTotalBags() {
        var total = 0;
        for (var key in selections) {
          total += selections[key].quantity;
        }
        return total;
      }

      function getSelectionsArray() {
        var arr = [];
        for (var key in selections) {
          arr.push(selections[key]);
        }
        return arr;
      }

      /* ── Dispatch selection change event ── */
      function dispatchChange() {
        var detail = {
          selections: getSelectionsArray(),
          totalBags: getTotalBags(),
          currentStyle: currentStyle,
        };
        listEl._hdcPlState = detail;
        listEl.dispatchEvent(
          new CustomEvent('hdc:pl-selection-change', {
            bubbles: true,
            detail: detail,
          }),
        );
      }

      /* ── Stock helpers ── */
      function getStockLimit(row) {
        var stockKey = currentStyle === 'whole' ? 'variantWholeStock' : 'variantGroundStock';
        var oversellKey = currentStyle === 'whole' ? 'variantWholeOversell' : 'variantGroundOversell';
        var oversellPolicy = row.dataset[oversellKey] || 'deny';
        if (oversellPolicy === 'continue') return Infinity;
        return parseInt(row.dataset[stockKey] || '0', 10);
      }

      /* ── Row UI ── */
      function updateRowUI(row, quantity) {
        var addBtn = row.querySelector('[data-hdc-pl-add-btn]');
        var qtySelector = row.querySelector('[data-hdc-pl-qty-selector]');
        var qtyValue = row.querySelector('[data-hdc-pl-qty-value]');
        var plusBtn = row.querySelector('[data-hdc-pl-qty-plus]');

        if (quantity === 0) {
          row.classList.remove('is-selected');
          if (addBtn) addBtn.classList.remove('is-hidden');
          if (qtySelector) qtySelector.classList.add('is-hidden');
        } else {
          row.classList.add('is-selected');
          if (addBtn) addBtn.classList.add('is-hidden');
          if (qtySelector) qtySelector.classList.remove('is-hidden');
          if (qtyValue) qtyValue.textContent = String(quantity);
        }

        // Cap indicator on plus button
        if (plusBtn) {
          var atLimit = quantity >= getStockLimit(row);
          plusBtn.classList.toggle('is-max', atLimit);
        }
      }

      /* ── Row availability ── */
      function updateRowAvailability() {
        var rows = listEl.querySelectorAll('[data-hdc-pl-row]');
        rows.forEach(function (row) {
          var availKey = currentStyle === 'whole' ? 'variantWholeAvailable' : 'variantGroundAvailable';
          var available = row.dataset[availKey] === 'true';
          var addBtn = row.querySelector('[data-hdc-pl-add-btn]');
          var qtySelector = row.querySelector('[data-hdc-pl-qty-selector]');
          var soldOut = row.querySelector('[data-hdc-pl-sold-out]');
          var handle = row.dataset.productHandle || '';

          if (!available) {
            row.classList.add('is-unavailable');
            if (addBtn) addBtn.classList.add('is-hidden');
            if (qtySelector) qtySelector.classList.add('is-hidden');
            if (soldOut) soldOut.classList.remove('is-hidden');

            if (selections[handle]) {
              delete selections[handle];
              row.classList.remove('is-selected');
            }
          } else {
            row.classList.remove('is-unavailable');
            if (soldOut) soldOut.classList.add('is-hidden');

            var selection = selections[handle];
            var limit = getStockLimit(row);
            if (selection && selection.quantity > limit) {
              selection.quantity = limit;
              if (selection.quantity === 0) {
                delete selections[handle];
              }
            }

            if (selection && selection.quantity > 0) {
              if (addBtn) addBtn.classList.add('is-hidden');
              if (qtySelector) qtySelector.classList.remove('is-hidden');
              updateRowUI(row, selection.quantity);
            } else {
              if (addBtn) addBtn.classList.remove('is-hidden');
              if (qtySelector) qtySelector.classList.add('is-hidden');
            }
          }
        });

        dispatchChange();
      }

      /* ── Per-row pricing ── */
      function updateProductRowPrices() {
        var totalBags = getTotalBags();
        var tier = getActiveTier(totalBags, discountTiers);
        var rows = listEl.querySelectorAll('[data-hdc-pl-row]');

        rows.forEach(function (row) {
          var baseCents =
            currentStyle === 'ground'
              ? parseInt(row.dataset.variantGroundPrice || '0', 10)
              : parseInt(row.dataset.variantWholePrice || '0', 10);

          var priceEl = row.querySelector('[data-hdc-pl-price]');
          var compareEl = row.querySelector('[data-hdc-pl-compare-price]');
          if (!priceEl) return;

          if (!tier || totalBags === 0) {
            priceEl.textContent = formatPrice(baseCents);
            if (compareEl) compareEl.style.display = 'none';
            return;
          }

          var percent = purchaseType === 'subscribe' ? tier.subscriptionPercent : tier.onetimePercent;
          var roundFn = purchaseType === 'subscribe' ? Math.floor : Math.round;
          var discount = roundFn((baseCents * percent) / 100);
          var salePrice = baseCents - discount;

          priceEl.textContent = formatPrice(salePrice);
          if (compareEl) {
            compareEl.textContent = formatPrice(baseCents);
            compareEl.style.display = '';
          }
        });
      }

      /* ── Image hover preview ── */
      function getHoverTarget() {
        if (!hoverTargetSelector) return null;
        return document.querySelector(hoverTargetSelector);
      }

      var currentImageSrc = null;
      function fadeToImage(src) {
        var target = getHoverTarget();
        if (!target || currentImageSrc === src) return;
        currentImageSrc = src;
        target.style.opacity = '0';
        setTimeout(function () {
          target.src = src;
          target.style.opacity = '1';
        }, 200);
      }

      function updateMainImage() {
        var target = getHoverTarget();
        if (!target) return;

        // Show active product from selections
        if (lastActiveHandle && selections[lastActiveHandle]) {
          fadeToImage(selections[lastActiveHandle].imageUrl);
          return;
        }

        // Active product not in selections — look up from DOM
        if (lastActiveHandle) {
          var row = listEl.querySelector('[data-product-handle="' + lastActiveHandle + '"]');
          if (row && row.dataset.productImage) {
            fadeToImage(row.dataset.productImage);
            return;
          }
        }

        // Fall back to first remaining selection
        var keys = Object.keys(selections);
        if (keys.length > 0) {
          fadeToImage(selections[keys[0]].imageUrl);
          return;
        }

        // Nothing selected — revert to default
        var defaultSrc = target.dataset.defaultSrc || target.src;
        fadeToImage(defaultSrc);
      }

      /* ── Click handlers ── */
      function handleAddClick(row) {
        var handle = row.dataset.productHandle;
        if (!handle) return;

        var data = getProductDataFromRow(row);
        data.quantity = 1;
        selections[handle] = data;
        lastActiveHandle = handle;

        updateRowUI(row, 1);
        updateProductRowPrices();
        updateMainImage();
        dispatchChange();
      }

      function handlePlusClick(row) {
        var handle = row.dataset.productHandle;
        if (!handle) return;

        var selection = selections[handle];
        if (!selection) return;
        if (selection.quantity >= getStockLimit(row)) return;

        selection.quantity += 1;
        lastActiveHandle = handle;

        updateRowUI(row, selection.quantity);
        updateProductRowPrices();
        updateMainImage();
        dispatchChange();
      }

      function handleMinusClick(row) {
        var handle = row.dataset.productHandle;
        if (!handle) return;

        var selection = selections[handle];
        if (!selection) return;

        selection.quantity -= 1;
        if (selection.quantity === 0) {
          delete selections[handle];
        }
        lastActiveHandle = handle;

        updateRowUI(row, selection.quantity);
        updateProductRowPrices();
        updateMainImage();
        dispatchChange();
      }

      /* ── Event delegation ── */
      listEl.addEventListener('click', function (e) {
        var target = e.target;
        var row = target.closest('[data-hdc-pl-row]');
        if (!row) return;

        if (target.closest('[data-hdc-pl-add-btn]')) {
          handleAddClick(row);
        } else if (target.closest('[data-hdc-pl-qty-plus]')) {
          handlePlusClick(row);
        } else if (target.closest('[data-hdc-pl-qty-minus]')) {
          handleMinusClick(row);
        } else {
          var handle = row.dataset.productHandle;
          if (handle) {
            lastActiveHandle = handle;
            updateMainImage();
          }
        }
      });

      /* ── Hover preview ── */
      var productRows = listEl.querySelectorAll('[data-hdc-pl-row]');
      productRows.forEach(function (row) {
        row.addEventListener('mouseenter', function () {
          if (hoverRevertTimer) {
            clearTimeout(hoverRevertTimer);
            hoverRevertTimer = null;
          }
          var image = row.dataset.productImage;
          if (image) fadeToImage(image);
        });
        row.addEventListener('mouseleave', function () {
          hoverRevertTimer = setTimeout(function () {
            currentImageSrc = null;
            updateMainImage();
            hoverRevertTimer = null;
          }, 50);
        });
      });

      /* ── Inbound events ── */
      listEl.addEventListener('hdc:pl-set-style', function (e) {
        currentStyle = e.detail.style;
        updateRowAvailability();
        updateProductRowPrices();
        updateMainImage();
      });

      listEl.addEventListener('hdc:pl-set-purchase-type', function (e) {
        purchaseType = e.detail.type;
        updateProductRowPrices();
        dispatchChange();
      });

      listEl.addEventListener('hdc:pl-remove-selection', function (e) {
        var handle = e.detail.handle;
        if (!handle || !selections[handle]) return;
        delete selections[handle];
        var row = listEl.querySelector('[data-product-handle="' + handle + '"]');
        if (row) updateRowUI(row, 0);
        updateProductRowPrices();
        updateMainImage();
        dispatchChange();
      });

      /* ── Store state on element for late-binding parents ── */
      listEl._hdcPlState = {
        selections: getSelectionsArray(),
        totalBags: getTotalBags(),
        currentStyle: currentStyle,
      };

      /* ── Auto-select first available row (deferred for parent scripts) ── */
      if (autoSelect) {
        requestAnimationFrame(function () {
          var firstRow = listEl.querySelector('[data-hdc-pl-row]:not(.is-unavailable)');
          if (firstRow) {
            handleAddClick(firstRow);
          }
        });
      }

      /* ── Initial pricing ── */
      updateProductRowPrices();
    }

    /* ── Auto-init all product lists on the page ── */
    document.querySelectorAll('[data-hdc-pl-list]').forEach(function (listEl) {
      initProductList(listEl);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hdc-progress-milestones"] && !Shopify.designMode) return;
  try {
    (function () {
    var tiers = null;

    function loadTiers() {
      if (tiers) return tiers;
      var el = document.querySelector('[data-discount-tiers]');
      if (!el) return null;
      tiers = JSON.parse(el.textContent);
      return tiers;
    }

    function updateMilestoneLabels(purchaseType) {
      var t = loadTiers();
      if (!t) return;
      document.querySelectorAll('[data-milestone-min-bags]').forEach(function (el) {
        var minBags = parseInt(el.dataset.milestoneMinBags || '0', 10);
        var tier = t.find(function (x) {
          return x.minBags === minBags;
        });
        if (!tier) return;
        var discountEl = el.querySelector('[data-milestone-discount]');
        if (!discountEl) return;
        var percent = purchaseType === 'subscribe' ? tier.subscriptionPercent : tier.onetimePercent;
        discountEl.textContent = 'Save ' + percent + '%';
      });
    }

    // Register listener eagerly so we never miss events from TS
    document.addEventListener('hdc:progress-update', function (e) {
      var detail = e.detail;
      var totalBags = detail.totalBags;
      var purchaseType = detail.purchaseType;
      var maxMilestone = 4;
      var fillPercent = Math.min((totalBags / maxMilestone) * 100, 100);

      document.querySelectorAll('[data-progress-fill]').forEach(function (el) {
        el.style.width = fillPercent + '%';
      });

      document.querySelectorAll('[data-milestone-min-bags]').forEach(function (el) {
        var minBags = parseInt(el.dataset.milestoneMinBags || '0', 10);
        el.classList.toggle('is-reached', totalBags >= minBags);
      });

      updateMilestoneLabels(purchaseType);
    });

    // Initial label render once DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        updateMilestoneLabels('subscribe');
      });
    } else {
      updateMilestoneLabels('subscribe');
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
